import React from 'react'

export default function ProgressCell({ rowData }) {
  const completed = rowData.completedResponses;
  const total = rowData.totalResponses;
  const percentage = rowData.completionPercentage;

  // Determine progress bar color based on completion percentage
  const getProgressColor = (percent) => {
    if (percent < 30) return 'bg-danger';
    if (percent < 70) return 'bg-warning';
    return 'bg-success';
  };

  return (
    <div className="d-flex flex-column" style={{ minWidth: '150px' }}>
      {/* Progress Bar */}
      <div className="progress mb-1" style={{ height: '8px' }}>
        <div
          className={`progress-bar ${getProgressColor(percentage)}`}
          role="progressbar"
          style={{ width: `${percentage}%` }}
          aria-valuenow={percentage}
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>

      {/* Progress Text */}
      <div className="d-flex justify-content-between align-items-center">
        <small className="text-muted">
          {completed}/{total} completed
        </small>
        <small className="fw-bold" style={{ color: percentage < 30 ? 'var(--danger)' : percentage < 70 ? 'var(--warning)' : 'var(--success)' }}>
          {percentage}%
        </small>
      </div>
    </div>
  );
};
